import { render, staticRenderFns } from "./PetProtectionTrendChart.vue?vue&type=template&id=1d73167f&"
import script from "./PetProtectionTrendChart.vue?vue&type=script&lang=js&"
export * from "./PetProtectionTrendChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports